import { useTranslation } from "react-i18next";
import { CrossIconForModal } from "../../AppIcons";
import $ from "jquery";
import Select from "react-select";
import { useEffect, useRef, useState } from "react";
import ReactMultiSelect from "../global/ReactMultiSelect";
import { getAxiosResponse, handleError } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import { useSelector } from "react-redux";
import Constants from "../../Constants";
import { deepEqual } from "../../services/Util";

export default function AdvanceFilter(prop) {

    const { t } = useTranslation();
    const translate = t;
    const selectRef = useRef(null);
    const multiSelectRef = useRef(null);

    const taskStatus = [
        { label: translate("tasks.tasks.all"), value: "" },
        { label: translate("tasks.tasks.open"), value: "OPEN" },
        { label: translate("tasks.tasks.completed"), value: "CLOSED" },
        { label: translate("tasks.tasks.rejected"), value: "REJECTED" },
        { label: translate("tasks.tasks.cancelled"), value: "CANCELLED" },
    ];

    const languageArray = [
      { label: translate("task_campaign.check_all"), value: "all" },
      { label: translate("task_campaign.uncheck_all"), value: "none" }
    ];

    const [selectedTaskStatus, setTaskStatus] = useState({label: translate("tasks.tasks.open"), value: "OPEN"});
    const [selectedTypeStatus, setTypeStatus] = useState({label: translate("tasks.tasks.all"), value: ""});
    const [selectedAssignee, setAssignee] = useState({label: translate("tasks.tasks.all"), value: ""});
    const [type, setType] = useState([]);
    const [assignees, setAssigneeFilter] = useState([]);
    const [selectedLanguages, setLanguage] = useState([]);
    const [selectedLanguagesString, setLanguageString] = useState([]);
    const [languageFilter, setLanguageFilter] = useState([]);

    const custBootstrapDataRedux = useSelector((store) => store.customer_bootstrap_data).value;
    const LoggedInUserId = custBootstrapDataRedux?.user?.userId;

    const extractTaskTypeEnums = (taskTypes) => {
      return taskTypes.map(taskType => taskType.originalEnum);
    };

  useEffect(() => {
    const { taskStatus, typeStatus, assignee, languages } = prop;
    taskStatus && setTaskStatus(taskStatus);
    typeStatus && setTypeStatus(typeStatus);
    assignee && setAssignee(assignee);
    languages && setLanguage(languages);
    
    const fetchTaskTypes = async () => {
        try {
            const res = await getAxiosResponse(APIUrls.ALL_TASK_TYPES);
            if (res.data) {
                const taskArray = res.data.data.result.map((task) => ({
                    label: translate("tasks.tasks." + task.code.toLowerCase()),
                    value: extractTaskTypeEnums(task.taskTypes),
                }));
                const taskArrayWithSelect = [
                    { label: translate("tasks.tasks.all"), value: "" },
                    ...taskArray,
                ];
                setType(taskArrayWithSelect);
            }
        } catch (err) {
            handleError(err);
        }
    };

    const fetchAssigneeList = async () => {
        try {
            const departmentParam = prop.department ? `?deptId=${prop.department}` : "";
            const res = await getAxiosResponse(APIUrls.CAMPAIGN_ASSIGNED_TO_LIST + departmentParam);
            if (res.data) {
                const assigneeArray = res.data.data.map((assignee) => {
                    const label = LoggedInUserId === assignee.userId ? translate('Me') : `${assignee.firstName.trim()} ${assignee.lastName.trim()}`;
                    return { label, value: assignee.userId };
                });

                if (!assigneeArray.some(assignee => assignee.label === translate('Me'))) {
                    assigneeArray.unshift({ label: translate('Me'), value: `${LoggedInUserId}` });
                }

                const sortedAssigneeArray = assigneeArray
                .filter(assignee => assignee.label !== translate('Me'))
                .sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));

                const assigneeArrayWithSelect = [
                    { label: translate("tasks.tasks.all"), value: "" },
                    { label: translate('Me'),  value: `${LoggedInUserId}`},
                    { label: translate("tasks.tasks.project_followers"), value: -1 },
                    ...sortedAssigneeArray,
                ];
                setAssigneeFilter(assigneeArrayWithSelect);
            }
        } catch (err) {
            handleError(err);
        }
    };

    const fetchLanguages = async () => {
        try {
            const departmentParam = prop.department ? `?deptId=${prop.department}` : "";
            const res = await getAxiosResponse(APIUrls.TASK_LANGUAGES + departmentParam);
            if (res.data.data) {
                res.data.data.map((language) => {
                  languageArray.push({
                    label: language.display,
                    value: language.code
                  });
                });
                setLanguageFilter(languageArray);
            }
        } catch (err) {
            handleError(err);
        }
    };

    Promise.all([fetchTaskTypes(), fetchAssigneeList(), fetchLanguages()]);
}, [prop.department]);

    function hideRightModel() {
        $('#advance-activeId').trigger('focus');
        prop.funct(false)
        document.body.classList.remove("modal-open");
    }

    const handleLanguageChange = (value) => {
      setLanguage(value);
      setLanguageString(value);
    };

    const handleInputChange = (e) => {
        if(e.length > 0) {
          $("#selected-lang-container").addClass("display-none");
        } else {
          $("#selected-lang-container").removeClass("display-none");
        }
    }

    $("#close-right-popup").on("keydown", function (e) {
        if (e.key === Constants.TAB) {
          if (e.shiftKey === true) {
            e.preventDefault();
            $("#apply-id").trigger("focus");
          }
        }
    });

    const handleModalFocus = (event) => {
        if (document.activeElement.id === "apply-id" && event.key === Constants.TAB &&
        event.shiftKey === false) {
            event.preventDefault();
            $("#close-right-popup").trigger("focus");
        }
    };

    const handleOnApply = () => {
        const selectedFilters = {
            "Languages" : selectedLanguagesString,
            "Assigned To" : selectedAssignee,
            "Type": selectedTypeStatus,
            "Status" : selectedTaskStatus
        };
        prop.onApply(selectedFilters);
        hideRightModel();
    }

    return (
        <div className="right-modal campaign-right-modal project-filters-modal" role="dialog" aria-labelledby="advanced-filters" aria-modal="true">
          <div className="modal-header flex">
            <div className="left flex-center" tabIndex={0}  >
              <strong id='advanced-filters'>{translate("project_listing.advanced_filters")}</strong>
            </div>
            <button className="close flex-center" aria-label="Close" onClick={hideRightModel}
                id='close-right-popup'>
              {CrossIconForModal}
            </button>
          </div>
          <div className="modal-content project-filter-content">
            <h4 aria-level={1}>{translate("project_listing.filter_by_column")}</h4>
            <div className="filter-selector">
                <div className="global-dropdown-block" ref={selectRef}>
                    <label>{translate("tasks.tasks.task_status")}</label>
                    <Select classNamePrefix='cw'
                        value={taskStatus.filter(function (option) {
                            return option.value === selectedTaskStatus.value;
                        })}
                        aria-label="Task Status"
                        options={taskStatus}
                        onChange={(e) => setTaskStatus(e)}
                    />
                </div>
                <div className="global-dropdown-block" ref={selectRef}>
                    <label>{translate("tasks.tasks.type")}</label>
                    <Select
                        classNamePrefix="cw"
                        value={type.filter(function (option) {
                            return deepEqual(option, selectedTypeStatus);
                        })}
                        aria-label="Type"
                        options={type}
                        onChange={(e) => setTypeStatus(e)}
                    />
                </div>
                <div className="global-dropdown-block" ref={selectRef}>
                    <label>{translate("tasks.tasks.assigned_to")}</label>
                    <Select
                        classNamePrefix="cw"
                        value={assignees.filter(function (option) {
                          return option.value == selectedAssignee.value;
                        })}
                        aria-label="Assigned to"
                        options={assignees}
                        onChange={(e) => setAssignee(e)}
                    />
                </div>

                <div className="global-dropdown-block global-multidropdown-check">
                    <label>{translate("tasks.tasks.language")}</label>
                    <ReactMultiSelect 
                        ref={multiSelectRef} 
                        value={selectedLanguages} 
                        option={languageFilter} 
                        callback={handleLanguageChange}
                        ariaLabel={'Language'}
                        placeholder={'Select '}
                        inputChange={handleInputChange}
                        filterType={'tasks'}
                        />
                </div>
                <div className="button-group flex">
                    <button className="btn default-btn first-focus" onClick={hideRightModel}>
                    {translate("project_listing.cancel")}
                    </button>
                    <button className="btn" id='apply-id' onClick={handleOnApply} onKeyDown={(e) => handleModalFocus(e)}>
                    {translate("project_listing.apply")}
                    </button>
                </div>
            </div>
          </div>
        </div>
      );
}